import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { DateTime } from 'luxon'

export const DayHeader = memo(function DayHeader(props: {
  dateTime: DateTime
  count: number
}) {
  const { dateTime, count } = props
  const { t, i18n } = useTranslation('feed')

  const todayStart = DateTime.now().startOf('day')
  const diffDays = Math.round(todayStart.diff(dateTime, 'days').days)

  let label: string
  if (diffDays === 0) {
    label = t('day.today')
  } else if (diffDays === 1) {
    label = t('day.yesterday')
  } else {
    label = dateTime
      .setLocale(i18n.language)
      .toLocaleString({ year: 'numeric', month: 'long', day: 'numeric' })
  }

  const countLabel = t('day.postCount', { count })

  return (
    <div className="sticky top-0 z-10 bg-background/80 backdrop-blur-sm border-b border-border">
      <div className="flex items-center justify-between px-4 py-2">
        <span className="text-sm font-semibold text-foreground">{label}</span>
        <span className="rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-muted-foreground">
          {countLabel}
        </span>
      </div>
    </div>
  )
})
